export default {
  path: '/travel-documents/prl-cargo',
  name: 'PrlCargo',
  component: () => import(/* webpackChunkName: "base" */ '../views/PrlCargoView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
